<vectronic-filter-header
  (titleClicked)="toggleShowFilter()"
  [title]="title()"
  [svgIcon]="svgIcon()"
  [icon]="icon()"
  (enabledFilterToggle)="toggleShowFilter()"
  [isFilterEnabled]="isFilterHidden()"
  [showLine]="false"
></vectronic-filter-header>
<mat-divider></mat-divider>
